import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable } from "rxjs";
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ReportsService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Reports');
	}

	DriverExport(date: Date): Observable<BlobResponse> {
		var convertDate = new Date(date);
		return this.myBaseService.postBlob(null, this.url + '/DownloadDriver?date=' + DateTime.fromJSDate(convertDate).toISO() + '&csv=false');
	}

	DriverExportCSV(date: Date): Observable<BlobResponse> {
		var convertDate = new Date(date);
		return this.myBaseService.postBlob(null, this.url + '/DownloadDriver?date=' + DateTime.fromJSDate(convertDate).toISO() + '&csv=true');
	}
	PropertyTypeDownload(custID: System.Guid, includeAccountSpecificTypes: boolean): Observable<BlobResponse> {
		return this.myBaseService.postBlob(null, this.url + '/PropTypes/' + (custID ||'').toString() + '?includeAccountSpecificTypes=' + (includeAccountSpecificTypes ?? false).toString());
	}
	ValuePerTruck(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/ValuePerTruck');
	}
	BulkMessageFailures(failures: any[]): Observable<BlobResponse> {
		return this.myBaseService.postBlob(failures, this.url + '/BulkMessageFailures');
	}
	ActiveAccountUsersReport(active?: boolean, ids?: System.Guid[]): Observable<BlobResponse> {
		return this.myBaseService.postBlob(ids ?? null, this.url + '/ActiveAccountUsersReport' + (active == null ? '' : '?active=' + active.toString()));
	}
	
	ValuePerPerson(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/ValuePerPerson');
	}

	ValuePerOrder(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/ValuePerOrder');
	}

	InvoicedPerServiceType(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/InvoicedPerServiceType');
	}

	StopsPerDay(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/StopsPerDay');
	}
	BusinessActivity(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/BusinessActivity');
	}

	DeliveriesAssemblies(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/DeliveriesAssemblies');
	}

	WarehouseStorage(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.WarehouseStorageReportDataClass[]> {
		return this.myBaseService.post(searchObj, this.url + '/WarehouseStorage?download=false', true);
	}
	WarehouseStorageDownload(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/WarehouseStorage?download=true');
	}

	WarehouseActivity(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.PropertyItemSpecialItem[]> {
		return this.myBaseService.post(searchObj, this.url + '/WarehouseActivity?download=false', true);
	}
	WarehouseActivityDownload(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/WarehouseActivity?download=true');
	}

	WarehouseProductivity(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.WarehouseProductivityReportData[]> {
		return this.myBaseService.post(searchObj, this.url + '/WarehouseProductivity?download=false', true);
	}
	WarehouseProductivityDownload(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/WarehouseProductivity?download=true');
	}

	StorageRevenue(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.StorageRevenueReportDataClass[]> {
		return this.myBaseService.post(searchObj, this.url + '/StorageRevenue?download=false', true);
	}
	StorageRevenueDownload(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/StorageRevenue?download=true');
	}
	DeliveryActivity(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.DeliveryActivityReportDataClass[]> {
		return this.myBaseService.post(searchObj, this.url + '/DeliveryActivity?download=false', true);
	}
	DeliveryActivityDownload(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/DeliveryActivity?download=true');
	}

	FeltPads(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.StorageRevenueReportDataClass[]> {
		return this.myBaseService.post(searchObj, this.url + '/FeltPads?download=false', true);
	}
	FeltPadsDownload(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/FeltPads?download=true');
	}

	FuelSurchargeDownload(): Observable<BlobResponse> {
		return this.myBaseService.postBlob(null, this.url + '/FuelSurcharges');
	}
	FuelSurchargeDownloadForCustomer(custID: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.postBlob(null, this.url + '/FuelSurcharges/' + (custID ?? this.myBaseService.configData.DefaultEmptyGuid));
	}
}

